module.exports = __webpack_public_path__ + "img/prefer_not_specify.ccf4459c.svg";